import request from 'utils/request';

const PREFIX = '/api/s3/';
export const S3Api = {
  REFRESH: PREFIX + 'refresh/related-number-file',
  UPLOAD_FILE: PREFIX + 'upload-file',
};

export function refreshDownloadUrl(params) {
  return request({
    url: S3Api.REFRESH,
    method: 'get',
    params,
  });
}

export function uploadFile(data) {
  return request({
    url: S3Api.UPLOAD_FILE,
    method: 'post',
    data,
  });
}
